import {BI_ENDPOINTS} from '@wix/wix-events-commons-statics'
import {schedulePageLoaded} from '../actions/page-loaded'
import {setLocation, setFilter, toggleTag} from '../actions/filter'
import {readDescriptionClicked, createBookmark, deleteBookmark, viewPersonalAgenda} from '../actions/schedule'
import {promptLogin, logout} from '../actions/member'
import {EventMap} from '../../../../commons/bi/interfaces'
import {
  handleSchedulePageLoaded,
  handleScheduleFilterApplied,
  handleScheduleItemDescriptionView,
  handleScheduledItemBookmarkClick,
  handleAgendaClick,
  handleMembersLoginClick,
} from './handlers'

export const eventMap: EventMap = {
  [schedulePageLoaded.toString()]: handleSchedulePageLoaded,
  [setLocation.fulfilled.toString()]: handleScheduleFilterApplied,
  [toggleTag.fulfilled.toString()]: handleScheduleFilterApplied,
  [setFilter.fulfilled.toString()]: handleScheduleFilterApplied,
  [readDescriptionClicked.toString()]: handleScheduleItemDescriptionView,
  [createBookmark.pending.toString()]: handleScheduledItemBookmarkClick,
  [deleteBookmark.pending.toString()]: handleScheduledItemBookmarkClick,
  [viewPersonalAgenda.pending.toString()]: handleAgendaClick,
  [promptLogin.pending.toString()]: handleMembersLoginClick,
  [logout.pending.toString()]: handleMembersLoginClick,
  endpoint: BI_ENDPOINTS.EVENTS_UOU,
}
